import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alerts-widget',
  templateUrl: './alerts-widget.component.html',
  styleUrls: ['./alerts-widget.component.less']
})
export class AlertsWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
